module.exports = __webpack_public_path__ + "img/baskerben-1.6fd46440.jpg";